var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.component)?_c(_vm.config.component,_vm._b({tag:"component",class:[_vm.classes]},'component',_vm.config.data || {},false)):(_vm.config.html)?_c('div',{class:[_vm.classes, 'html'],domProps:{"innerHTML":_vm._s(_vm.config.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }